import { Command, CommandResult } from '../procedure.interface';
import { Device } from '@/device';
import { InstallProperties, OculeraProperties } from '@/interfaces/properties.interface';
import { Logger } from '@/logger';

const S3_BUCKET = '/proxy/oculera_s3';

export class InstallOculeraCommand implements Command {
  public stopOnError: boolean;
  public type: string;

  constructor() {
    this.stopOnError = true;
    this.type = 'installOculera';
  }

  public toLog(): string {
    return 'Installing Oculera APK';
  }

  public async execute(device: Device, logger: Logger, properties?: InstallProperties): Promise<CommandResult> {
    if (!properties || (properties && properties.procedure !== 'Oculera')) {
      throw new Error('Only OCULERA procedure is compatible with this command');
    }
    const parameters = properties.properties as OculeraProperties;
    let path = 'oculeraApk/oculera_latest.apk';
    switch (parameters.oculera_version) {
      case '2.3.0':
        path = 'oculera_2_3.apk';
        break;
      case '2.6.4':
        path = 'oculeraApk/oculera_2_6_4.apk';
        break;
      default:
        break;
    }
    const apkPath = `${S3_BUCKET}/${path}`;
    // Generate the URL for the latest APK
    let code = -1;
    try {
      code = await device.installApkFromUrl(apkPath, logger.logProgress('Downloading APK'));
    } catch (error: unknown) {
      return Promise.resolve({
        success: false,
        message: (error as Error).message,
      });
    }
    return Promise.resolve({
      success: code === 0,
      message: code === 0 ? 'APK installed' : 'APK installation failed',
    });
  }
}
